import React from 'react';
import cx from 'classnames';
import Countdown from 'react-countdown';
import styles from './index.module.scss.js';

const TIMER_DEFAULT_TEXT = {
  days: "Days",
  hours: "Hours",
  minutes: "Minutes",
  seconds: "Seconds"
};
const TimerBanner = ({
  date,
  showDays = true,
  showSeconds,
  size = "md",
  text = TIMER_DEFAULT_TEXT,
  className,
  style,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cx(styles.box, className, {
      [styles[size]]: !!size
    }),
    style,
    ...props
  },
  /* @__PURE__ */ React.createElement(
    Countdown,
    {
      date,
      renderer: ({ days, hours, minutes, seconds }) => {
        const dd = days ? days < 10 ? `0${days}` : days : "00";
        const hh = hours ? hours < 10 ? `0${hours}` : hours : "00";
        const mm = minutes ? minutes < 10 ? `0${minutes}` : minutes : "00";
        const ss = seconds ? seconds < 10 ? `0${seconds}` : seconds : "00";
        return /* @__PURE__ */ React.createElement(
          "div",
          {
            className: cx(styles.timer, showSeconds && styles["timer-seconds"]),
            "data-timer-wrapper": true
          },
          showDays && /* @__PURE__ */ React.createElement("div", { className: cx(styles["timer-col"]), "data-timer-col": true }, /* @__PURE__ */ React.createElement("span", null, String(dd)[0]), /* @__PURE__ */ React.createElement("span", null, String(dd)[1]), /* @__PURE__ */ React.createElement("div", { className: cx(styles.description) }, text.days)),
          /* @__PURE__ */ React.createElement("div", { className: cx(styles["timer-col"]), "data-timer-col": true }, /* @__PURE__ */ React.createElement("span", null, String(hh)[0]), /* @__PURE__ */ React.createElement("span", null, String(hh)[1]), /* @__PURE__ */ React.createElement("div", { className: cx(styles.description) }, text.hours)),
          /* @__PURE__ */ React.createElement("div", { className: cx(styles["timer-col"]), "data-timer-col": true }, /* @__PURE__ */ React.createElement("span", null, String(mm)[0]), /* @__PURE__ */ React.createElement("span", null, String(mm)[1]), /* @__PURE__ */ React.createElement("div", { className: cx(styles.description) }, text.minutes)),
          showDays && showSeconds && /* @__PURE__ */ React.createElement(
            "div",
            {
              className: cx(styles["timer-col"], styles["timer-seconds"]),
              "data-timer-col": true
            },
            /* @__PURE__ */ React.createElement("span", null, String(ss)[0]),
            /* @__PURE__ */ React.createElement("span", null, String(ss)[1]),
            /* @__PURE__ */ React.createElement("div", { className: cx(styles.description) })
          ),
          !showDays && /* @__PURE__ */ React.createElement("div", { className: cx(styles["timer-col"]), "data-timer-col": true }, /* @__PURE__ */ React.createElement("span", null, String(ss)[0]), /* @__PURE__ */ React.createElement("span", null, String(ss)[1]), /* @__PURE__ */ React.createElement("div", { className: cx(styles.description) }, text.seconds))
        );
      }
    }
  )
);
TimerBanner.displayName = "TimerBanner";

export { TIMER_DEFAULT_TEXT, TimerBanner };
//# sourceMappingURL=index.js.map
